import { Col, Row } from 'antd';
import Logo from 'assets/images/generateTAX-logo.svg';
import { CenterLogo } from 'components/Custom/logo';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import routes from 'routes';
import styled from 'styled-components';

const LogoWrap = styled.div`
  margin-bottom: 28px;
`;

const LegalDocumentPage = styled(Row)`
  background-color: var(--color-layout-bg, #eaf6f7);
  min-height: 100vh;
`;

const LegalDocumentCard = styled(Col)`
  background-color: var(--color-surface-base, #ffffff);
  padding: 20px 60px;
  color: var(--color-text-base, #2e2e2e);

  .ant-typography {
    color: var(--color-text-base, #2e2e2e);
  }

  h1.ant-typography,
  h2.ant-typography,
  h3.ant-typography,
  h4.ant-typography,
  h5.ant-typography {
    color: var(--color-text-dark, #042a2a);
  }

  a {
    color: var(--color-link, #5e87b0);
  }

  a:hover {
    color: var(--color-link-hover, #406182);
  }
`;

/** Restores bullets + readable spacing (global reset removes list-style / uses line-height: 1). */
export const LegalDocumentList = styled.ul`
  list-style-type: disc !important;
  list-style-position: outside !important;
  padding-left: 28px !important;
  margin: 8px 0 16px !important;
  font-size: 14px;
  font-weight: 300;
  line-height: 1.6 !important;
  color: var(--color-text-base, #2e2e2e);

  > li {
    display: list-item !important;
    list-style-type: disc !important;
    margin-bottom: 10px;
    line-height: 1.6 !important;
    padding-left: 4px;
  }
`;

type LegalDocumentLayoutProps = {
  children: React.ReactNode;
};

export const LegalDocumentLayout: React.FC<LegalDocumentLayoutProps> = ({
  children,
}) => {
  const { t } = useTranslation();

  return (
    <LegalDocumentPage justify="center">
      <LegalDocumentCard span={15}>
        <LogoWrap>
          <Link to={routes.home} aria-label={t('navigation.logo-alt')}>
            <CenterLogo src={Logo} alt={t('navigation.logo-alt')} />
          </Link>
        </LogoWrap>
        {children}
      </LegalDocumentCard>
    </LegalDocumentPage>
  );
};
